import React, { useState } from "react"
import dynamic from "next/dynamic"
import Link from "next/link"
import { useRouter } from "next/router"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCommentAlt,
  faHeart,
  faHome,
  faRulerHorizontal,
  faUser,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons"
import { AuthContextType, useAuthContext } from "../../modules/auth/authContext"

export const BottomMobNavBarStyled = styled.div`
  width: 100%;
  height: 100%;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  z-index: 200;
  background-color: white;

  > .container {
    display: flex;
    width: 100%;
    height: 100%;
    flexdirection: row;
  }

  @media (max-width: 800px) {
    display: initial;
  }
  @media (min-width: 800px) {
    display: none !important;
  }
  color: black;

  .bottomButton {
    color: #717171;
    flex: 1;
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
    }
    .name {
      font-size: 10px;
      line-height: 12px;
    }
  }
  @media (max-width: 600px) {
    position: fixed;
    top: initial !important;
    bottom: 0px !important;
    border-top: 1px solid rgb(221, 221, 221) !important;
  }
  .selected {
    color: var(--moje-color-magenta) !important;
  }
`

export const BottomMobNavBar = (props) => {
  const authContext: AuthContextType = useAuthContext()
  const router = useRouter()
  const bottomButton = (title, icon, href) => {
    const isSelected = router.pathname == href
    return (
      <Link href={href}>
        <div className={`bottomButton ${isSelected ? "selected" : ""}`}>
          <div className="icon">
            <FontAwesomeIcon icon={icon} />
          </div>
          <div className="name">{title}</div>
        </div>
      </Link>
    )
  }

  return (
    <BottomMobNavBarStyled>
      <div className="container">
        {bottomButton("Oferty", faHome, "/miejsca")}
        {/* {bottomButton("Ulubione", faHeart, "/me/bookmarks")} */}
        {bottomButton("Zapytania", faHeart, "/me/reservations")}
        {bottomButton("Wiadomości", faCommentAlt, "/me/messages")}
        {bottomButton("Profil", faUserAlt, "/me/profile")}
      </div>
    </BottomMobNavBarStyled>
  )
}
